import * as React from "react";
const SvgFiRrAngry = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-angry_svg__a)">
      <path
        fill="#062147"
        d="M19 8a1 1 0 0 1-1 1 2.3 2.3 0 0 0-1.47.41A1.5 1.5 0 1 1 14 10.481c0-.981.707-3.475 4-3.481a1 1 0 0 1 1 1M7 10.5a1.5 1.5 0 1 0 3-.019C10 9.5 9.292 7.006 6 7a1 1 0 0 0 0 2 2.3 2.3 0 0 1 1.472.409A1.5 1.5 0 0 0 7 10.5M24 12a12.013 12.013 0 0 1-12 12C-3.9 23.4-3.894.6 12 0a12.013 12.013 0 0 1 12 12m-2 0A10.01 10.01 0 0 0 12 2c-13.248.5-13.245 19.5 0 20a10.01 10.01 0 0 0 10-10m-4.334 4.254a8.375 8.375 0 0 0-11.332 0 1 1 0 0 0 1.33 1.494 6.36 6.36 0 0 1 8.67 0 1 1 0 1 0 1.332-1.494"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-angry_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAngry;
